// This is a Mixin that extends the base functionality
// of MpNotes Controller, for news search page (registered users)
var MpSearchNotes = {
    created: function () {},
    data: function() {
        return {
            SEARCH_PAGE_URL: '/notes/search/format/json/page/',

            DATE_PICKER_CONFIG: {
                mode: 'range',
                defaultDate: null,
                maxDate: 'today',
                dateFormat: 'Y-m-d',
                altInput: true,
                altFormat: 'd/m/Y',
                locale: COUNTRY, /// Global variable injected via php BaseController
                shorthandCurrentMonth: true
            },

            word: '',

            dateRange: null,
            dateStart: '',
            dateEnd: '',
            dt_start: '',
            dt_end: '',
            dateAll: null,

            origin: '',
            filters: '',

            totalResultsTPL: '',
            totalItems: 0,
            originOptionList: [],

            allChecked: false,
            isSearchActive: SHOW_ADVANCED,
        };
    },

    computed: {

        isFilteredByOrigin: function() {
            return this.origin;
        },

        dataFilters: function() {

            return Serializer.serialize({
                'date-start': this.dateStart,
                'date-end': this.dateEnd,
                'dt_start': this.dt_start,
                'dt_end': this.dt_end,
                'word': this.word,
                'origin': this.origin,
                'filters': this.filters
            });
        },

        totalResults: function () {
            return this.totalResultsTPL.replace('%s', this.totalItems);
        },

    },

    methods: {

        getDateFromString: function(dateStr) {
            var dateParts = dateStr.split('-');
            return new Date(parseInt(dateParts[0]), parseInt(dateParts[1])-1, parseInt(dateParts[2]));
        },

        addOriginOption: function(originItem) {
            this.originOptionList.push(originItem);

            if (originItem.getAttribute('selected')) {
                this.origin = originItem.value;
            }
        },

        showFilters: function() {
            this.isSearchActive = !this.isSearchActive;
        },

        resetFilters: function() {
            this.word = '';
            this.setAllDates(true);
            this.origin = '';

            this.filters = 'reset'; // to reset server session filters
            this.loadItems();
        },

        setAllDates: function(state) {
            this.dateAll = state;

            if (this.dateAll) {
                this.dateRange = null;
                this.dateStart = '';
                this.dateEnd = '';
                this.dt_start = '';
                this.dt_end = '';
            }
        },

        onDateChange: function(dateSelection) {
            if (dateSelection.length === 2) {
                this.setAllDates(false);

                this.dateStart = DateHelper.getDateObjString(dateSelection[0]);
                this.dateEnd = DateHelper.getDateObjString(dateSelection[1]);
                this.dt_start = this.dateStart;
                this.dt_end = this.dateEnd;
            }
        },

        onSearchLoaded: function(response) {
            if (response.data.result == this.RESPONSE_OK) {
                this.itemList = response.data.notes;
                this.totalItems = response.data.total;
                this.updatePaginator(response);
            }
        },

        loadItems: function(isPagination) {
            if (!isPagination && this.page !== 1) {
                this.setPage(1);
            }

            // Set proper filters value depending the request type
            this.filters = (!isPagination) ? (this.filters || 'ok') : '';

            axios
                .post(this.SEARCH_PAGE_URL + this.page, this.dataFilters)
                .then(this.onSearchLoaded)
                .catch(function(error) {
                    console.log(error);
                });
        },

        sendForm: function() {
            // TODO: validate filters?
            if (true) {
                this.loadItems();
            }
        },

        init: function() {

        }
    },

    mounted: function() {
        this.$refs.ssrItemList.querySelectorAll('.js-item').forEach(this.addDomItem);
        this.$refs.ssrOriginList.querySelectorAll('.js-origin-option').forEach(this.addOriginOption);

        this.word = this.$refs.word.getAttribute('data-init');
        this.totalResultsTPL = this.$refs.ssrTotalItems.getAttribute('data-tpl');
        this.totalItems = this.$refs.ssrTotalItems.getAttribute('data-total');

        this.dateRange = (DATE_START_USER && DATE_END_USER) ? [DATE_START_USER, DATE_END_USER] : null;
        this.dateStart = DATE_START_USER;
        this.dateEnd = DATE_END_USER;
        this.dt_start = this.$refs.dt_start.getAttribute('data-init');
        this.dt_end = this.$refs.dt_end.getAttribute('data-init');
        this.filters = this.$refs.filters.getAttribute('data-init');
        this.dateAll = (this.$refs.dateAll.getAttribute('data-init') == true);
        this.setAllDates(this.dateAll);
    },
};
